import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const About = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/stats`);
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching stats:', error);
        setStats({
          contracts_fulfilled: 100,
          tons_printed: 50000,
          years_heritage: 11,
          government_clients: 10
        });
      }
    };
    fetchStats();
  }, []);

  if (!stats) {
    return null;
  }

  const statItems = [
    { value: stats.contracts_fulfilled, suffix: '+', label: 'Projects Delivered' },
    { value: stats.government_clients, suffix: '+', label: 'Government Clients' },
    { value: stats.years_heritage, suffix: '+', label: 'Years Experience' },
    { value: '99', suffix: '%', label: 'On-Time Delivery' }
  ];

  return (
    <section id="about" className="bg-white section-padding" data-testid="about-section" aria-labelledby="about-heading">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <article>
            <p className="overline mb-4" data-testid="about-overline">
              About Our Printing Press
            </p>
            <h2 id="about-heading" className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight font-heading text-[#1a1a1a] mb-6" data-testid="about-heading">
              Trusted Printing Partner
              <br />
              Since 2015
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed" data-testid="about-description">
              <p>
                <strong>AURUM PRINTS ASSOCIATES</strong> is a leading <strong>ISO 9001:2015 certified printing press</strong> specializing 
                in <strong>commercial printing</strong>, <strong>government contract printing</strong>, <strong>magazine printing</strong>, 
                <strong>book printing</strong>, <strong>notebook manufacturing</strong>, and professional <strong>binding & finishing services</strong>.
              </p>
              <p>
                Our state-of-the-art facility houses advanced <strong>offset printing</strong> and <strong>web printing</strong> machines 
                capable of handling high-volume orders with exceptional color accuracy and consistency. We serve 
                <strong> government agencies</strong>, <strong>public sector undertakings</strong>, <strong>publishers</strong>, 
                and <strong>Fortune 500 companies</strong>.
              </p>
              <p>
                With <strong>{stats.years_heritage}+ years of industry experience</strong> and a track record of 
                <strong> {stats.contracts_fulfilled}+ successful projects</strong>, we are your reliable partner for all printing needs.
              </p>
            </div>
          </article>

          {/* Right: Stats Grid */}
          <div className="grid grid-cols-2 gap-4" data-testid="stats-grid">
            {statItems.map((stat, index) => (
              <div
                key={index}
                className="bg-gray-50 p-6 rounded-lg text-center"
                data-testid={`stat-item-${index}`}
              >
                <div className="text-3xl sm:text-4xl font-extrabold font-heading text-[#003151]">
                  {stat.value}{stat.suffix}
                </div>
                <div className="text-sm text-gray-600 mt-2">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Facility Image */}
        <figure className="mt-16 overflow-hidden rounded-lg" data-testid="credibility-image">
          <img
            src="https://images.pexels.com/photos/6620985/pexels-photo-6620985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Professional printing press facility with advanced offset and web printing equipment"
            className="w-full h-64 object-cover"
            loading="lazy"
            width="940"
            height="256"
          />
          <figcaption className="sr-only">Our modern printing facility equipped with latest offset and web printing technology</figcaption>
        </figure>
      </div>
    </section>
  );
};

export default About;
